import { useEffect, useState } from "react";

const KEY = "imm-theme";
const read = () => {
  try { return localStorage.getItem(KEY) || "light"; } catch { return "light"; }
};
let current = read();
const subs = new Set();

export function getTheme() { return current; }
export function setTheme(t) {
  current = t === "light" ? "light" : "dark";
  try { localStorage.setItem(KEY, current); } catch {}
  subs.forEach((fn) => fn(current));
}
export function toggleTheme() { setTheme(current === "dark" ? "light" : "dark"); }

/** Subscribe a component to the shared immersive theme (default "light"). */
export function useImmTheme() {
  const [t, setT] = useState(current);
  useEffect(() => {
    const fn = (v) => setT(v);
    subs.add(fn);
    setT(current);
    return () => subs.delete(fn);
  }, []);
  return t;
}
